import React, { useState } from 'react'
import { Row, Col, Container, FormGroup, Image } from 'react-bootstrap'
import { useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'
import * as yup from 'yup'
//
import ReactstrapInput from '../components/ReactstrapInput'
import ButtonX from '../components/common/ButtonX'
import { CLASSES, COLORS } from '../assets/styles/styles'
import LocationImage from '../assets/icons/contact/location.svg'
import PhoneImage from '../assets/icons/contact/phone.svg'
import EmailImage from '../assets/icons/contact/message.svg'
import HomePageService from '../services/HomePageService'
import Swal from 'sweetalert2'

function ContactUs({ data }) {
  // const { showSuccessAlert, showFailedAlert } = useAlert()
  const [loading, setLoading] = useState(false)
  const { address, email_1, email_2, facebook_link, phone_number } = data || {}
  const {
    formState: { errors },
    // setError,
    reset,
    control,
    handleSubmit,
  } = useForm({
    mode: 'submit',
    defaultValues: {},
    resolver: yupResolver(
      yup.object().shape({
        name: yup
          .string()
          .trim()
          .max(250, 'Name should be 250 characters or less')
          .required('Name is required'),
        email: yup
          .string()
          .trim()
          .max(250, 'Email should be 250 characters or less')
          .required('Email is required'),
        phone: yup
          .string()
          .trim()
          .max(11, 'Phone should be 11 characters')
          .min(11, 'Phone should be 11 characters')
          .required('Phone is required'),
        message: yup
          .string()
          .trim()
          .max(500, 'Message should be 500 characters or less')
          .required('Message is required'),
      }),
    ),
  })

  const onSubmit = async (values) => {
    // console.log(values)
    setLoading(true)
    try {
      // const response = await CategoryService.create_or_update(values)
      // if (response?.success) {
      //   showSuccessAlert({
      //     title: `${language.category} ${
      //       categoryId
      //         ? language.updated_successfully
      //         : language.created_successfully
      //     }`,
      //   })
      //   onClose()
      //   refreshTable()
      // } else {
      //   if (response?.error) {
      //     Object.keys(response?.error).forEach((key) => {
      //       setError(key, {
      //         type: 'manual',
      //         message: response?.error[key][0],
      //       })
      //     })
      //   } else {
      //     showFailedAlert()
      //   }
      // }
    } catch (error) {
      console.log('error', error)
      // showFailedAlert()
    } finally {
      setLoading(false)
    }
  }

  const handleSubscription = async (values) => {
    // console.log(values)
    // return
    try {
      setLoading(true)
      const response = await HomePageService.subscription(values)
      // const response = {success: true}
      if (response.success) {
        Swal.fire({
          title: response.message,
          icon: 'success',
          showConfirmButton: false,
          timer: 2000,
        }).then((result) => {
          /* Read more about handling dismissals below */
          if (result.dismiss === Swal.DismissReason.timer) {
            console.log('I was closed by the timer')
          }
        })
      }
    } catch (error) {
      console.log(error)
    } finally {
      reset()
      setLoading(false)
    }
  }

  const inputStyles = {
    borderRadius: 0,
    border: 'none',
    borderBottom: '1px solid #8D8D8D',
  }
  return (
    <div style={{ backgroundColor: COLORS.theme_light_low }}>
      <Container className='px-4'>
        <header className='text-center my-5'>
          <h2>Contact us</h2>
          <p className='mt-4 text-muted text-bold'>
            Any question or remarks? Just write us a message!
          </p>
        </header>

        <Row className='bg-theme-light py-4 mb-5'>
          <Col md={4} style={{ height: 500 }}>
            <div
              className={
                'text-white rounded p-5 h-100 d-flex flex-column gap-4 position-relative'
              }
              style={{ backgroundColor: COLORS.theme }}
            >
              <div
                style={{
                  backgroundColor: '#FFF9F921',
                  height: 140,
                  width: 140,
                  borderRadius: '50%',
                  position: 'absolute',
                  bottom: '15%',
                  right: '15%',
                  zIndex: 1,
                }}
              />
              <div
                style={{
                  backgroundColor: '#FFFFFF1F',
                  height: 270,
                  width: 270,
                  borderRadius: '50%',
                  position: 'absolute',
                  bottom: '-15%',
                  right: '-15%',
                  zIndex: 1,
                }}
              />
              <h3 className='mb-4'>Contact Information</h3>
              {phone_number && (
                <div className={CLASSES.items_center + ' mb-3 gap-4'}>
                  <Image src={PhoneImage} />
                  <div style={{ fontSize: 14 }}>{phone_number}</div>
                </div>
              )}
              {email_1 && (
                <div className={CLASSES.items_center + ' mb-3 gap-4'}>
                  <Image src={EmailImage} />
                  <div style={{ fontSize: 14 }}>actualgreeen@gmail.com</div>
                </div>
              )}
              {address && (
                <div className={CLASSES.items_center + ' mb-3 gap-4'}>
                  <Image src={LocationImage} />
                  <div style={{ fontSize: 14 }}>
                    22/1 Block-B(3rd Floor) Babar Road. Mohammadpur, Dhaka -1207
                  </div>
                </div>
              )}
            </div>
          </Col>
          <Col md={8} className='px-4 px-md-5 mt-5 text-bold'>
            <Row className=''>
              <ReactstrapInput
                label={'Full Name'}
                name={'name'}
                type={'text'}
                placeholder={'Write here...'}
                errorMessage={errors?.name?.message}
                control={control}
                required
                style={inputStyles}
              />
            </Row>
            <Row className='mt-3'>
              <ReactstrapInput
                label={'Email'}
                name={'email'}
                type={'text'}
                placeholder={'Write here...'}
                errorMessage={errors?.email?.message}
                control={control}
                required
                style={inputStyles}
              />
              <ReactstrapInput
                label={'Phone'}
                name={'phone'}
                type={'number'}
                placeholder={'Write here...'}
                errorMessage={errors?.phone?.message}
                control={control}
                required
                style={inputStyles}
              />
            </Row>
            <Row className='mt-3'>
              <ReactstrapInput
                label={'Message'}
                name={'message'}
                as={'textarea'}
                rows={1}
                placeholder={'Write here...'}
                errorMessage={errors?.message?.message}
                control={control}
                noGrid
                required
                style={inputStyles}
              />
            </Row>
            <Row>
              <Col>
                <FormGroup className={CLASSES.content_end}>
                  <ButtonX
                    label={loading ? 'SENDING...' : 'Send Message'}
                    disabled={loading}
                    onClick={handleSubmit(handleSubscription)}
                    className='px-4 border-0'
                    color='#011C2A'
                  />
                </FormGroup>
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>
    </div>
  )
}

export default ContactUs
